import ShoppingCart from "./ShoppingCart";
import usePhysicalProducts from "../../hooks/usePhysicalProducts";
import { useState } from "react";

interface Props {
  hideSmall?: boolean;
  onlyShowTotals?: boolean;
  action: "review" | "checkout" | null;
  checkoutDetails?: {
    shippingMethod: string;
    addressState?: string;
  };
  children: any;
}

export default function WithCart(props: Props) {
  usePhysicalProducts();

  return (
    <div className="w-full flex flex-col lg:flex-row justify-between h-full">
      <div className="lg:w-7/12 py-12">{props.children}</div>
      <div
        className={`lg:w-4/12 ${
          props.onlyShowTotals
            ? "lg:py-12 lg:sticky"
            : "py-6 lg:py-12 sticky bottom-0 border-t lg:border-t-0"
        } lg:top-0 lg:self-start h-full bg-secondary ${
          props.hideSmall ? "hidden lg:block" : ""
        }`}
      >
        <ShoppingCart
          onlyShowTotals={props.onlyShowTotals}
          action={props.action}
          checkoutDetails={props.checkoutDetails}
        />
      </div>
    </div>
  );
}
